import { Injectable, OnInit } from "@angular/core";
import { Standard } from "../models/standard.model";
import { Http } from "@angular/http";
import { ApiConnectService } from "./api-connect.service";
import { Router } from "@angular/router";
import { AdminService } from "./admin.service";
import { Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { User } from "../models/user.model";
import { MultiQuestions } from "../models/multi-questions";
import { NewBlank } from "../models/new-blank.model";
import { TreeGroupPosService } from "../content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos.service";

@Injectable()
export class StepsControllerService {
  currentStandardOK = false;
  activeStep = 1;
  canGoToDiscussion = false;

  public showByFilesAndBlanks = false;

  // FOR CONTROL NEXT BUTTON IN 2'nd STEP
  public nextToCreate = false;
  public unlockSThree = false;
  public dataStandard = null;
  public dataStandardFormData: FormData = new FormData();
  public dataStandardNewBlanks: NewBlank[] = [];
  public dataStandardHasGroups = false;
  public disGtn = false;
  public dataStandardFilesUploadError = false;
  public dataStandardErrorExists = false;
  public dataStandardErrorCreating = false;

  stepOneDisabled = false;
  stepTwoDisabled = false;
  stepThreeDisabled = true;
  stepFourDisabled = true;
  stepFiveDisabled = true;
  stepSixDisabled = true;
  stepSevenDisabled = true;
  stepEightDisabled = true;
  navPreviousDisabled = true;
  navNextDisabled = true;
  public currentStandard = null;
  tempData: any;
  notifyType = "";

  private editActive = false;
  private editActiveWithNotification = false;

  private tempID = null;
  private logsID = null;

  private userLang = "No lang.";
  private user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private treeGroupPosService: TreeGroupPosService,
    private apiURL: ApiConnectService,
    private router: Router,
    private adminService: AdminService
  ) {
    this.checkRole();
  }

  
  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } 
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } 
  }

  setLocalUserLang() {
    // Check user language and set userLang var
    this.user = this.userService.getLocal();
    switch (this.user.language.toLowerCase()) {
      case "russian":
        this.userLang = "Ru";
        break;
      case "english":
        this.userLang = "En";
        break;
      default:
        this.userLang = "No lang.";
        break;
    }
  }

  getLocalUserLanguage() {
    if (this.getCurrentStandard() !== null) {
      switch (this.getCurrentStandard().language) {
        case "russian":
          this.userLang = "Ru";
          break;
        case "english":
          this.userLang = "En";
          break;
        default:
          this.userLang = "No lang.";
          break;
      }
    }
    return this.userLang;
  }

  updateCurrentStandartFromApi() {
    return this.adminService.getStandard(this.getCurrentStandard().id);
  }

  // Проверить текущие данные для инита на Шаге 1,
  // когда лазишь по шагам при создании.
  hasCurrentData() {
    return !!this.tempData;
  }

  // Проверить текущий стандарт для инита на Шаге 1,
  // когда заходишь на шаг 1 из списка станадртов.
  hasCurrentStandard() {
    return this.currentStandard !== null;
  }

  // Удалить tempData, когда уходишь из компонента с 7-ю шагами;
  clearTempData() {
    this.tempData = null;
  }

  // Удалить currentStandard, когда уходишь из компонента с 7-ю шагами;
  clearCurrentStandard() {
    this.currentStandard = null;
  }

  // Создание станадарта на первом шаге.
  createHeadStandard(data) {
    return this.http.post(this.apiURL.createHeadStandard, data);
    // return this.http.post(this.apiURL.createHeadStandard, data);
  }

  createOrUpdateHeadStandard(data, createAction, createActionStandardID) {
    if (createAction) {
      return this.http.post(this.apiURL.createHeadStandard, data, {
        observe: "response"
      });
    } else {
      const updatedData = {
        id: createActionStandardID,
        status: data.status,
        standardType: data.standardType,
        ruName: data.ruName,
        enName: data.enName,
        ruAnnotation: data.ruAnnotation,
        enAnnotation: data.enAnnotation,
        language: data.language,
        linkedGroups: data.linkedGroups,
        confirmedGroups: data.confirmedGroups,
        linkedUsers: data.linkedUsers,
        confirmedUsers: data.confirmedUsers,
        linkedPositions: data.linkedPositions,
        confirmedPositions: data.confirmedPositions,
        standardDisseminationPositions: data.standardDisseminationPositions
      };
      return this.http.put(this.apiURL.updateHeadStandard, updatedData, {
        observe: "response"
      });
    }
  }

  // Редактирование станадарта на первом шаге.
  updateHeadStandard(data) {
    return this.http.put(this.apiURL.updateHeadStandard, data);
  }

  // Получить все группы, где текущий авторизованный пользователь
  // является главой или заместителем (для заполнения списка групп-инициаторов).
  getAllHeadingGroups() {
    return this.http.get(this.apiURL.getAllHeadingGroups, {
      observe: "response"
    });
  }

  // Устанавливать текущий станадарт при пареходе
  // на него из списка стандартов или уведомлений.
  setCurrentStandard(standard) {
    this.currentStandard = standard;
      // Go to step 8
      this.setNotifyType("");
      this.activeStep = 8;
      this.stepOneDisabled = true;
      this.stepTwoDisabled = true;
      this.stepThreeDisabled = true;
      this.stepFourDisabled = true;
      this.stepFiveDisabled = true;
      this.stepSixDisabled = true;
      this.stepSevenDisabled = true;
      this.stepEightDisabled = false;
      if (!this.currentStandard.hasOwnProperty("id")) {
        this.router.navigate([
          "/dashboard/create-operating-standard/step-eight"
        ]);
      } else {
        this.router.navigate([
          "/dashboard/create-operating-standard/step-eight"
        ]);
    }
  }

  checkListsLengthExecute() {
    return (
      this.currentStandard.linkedGroups.length > 0 ||
      this.currentStandard.linkedPositions.length > 0 ||
      this.currentStandard.linkedUsers.length > 0
    );
  }

  // Проверить все ли поля заполнены. Если да, то на шаг 3,
  // если, нет, то на шаг 1-2. Плюс смотреть на статус, если все поля заполнены.
  isRequiredAllFields() {
    // FOR ACTIVE STANDARDS
    // Go to step 7
    if (
      this.currentStandard.status === "ACTIVE" ||
      this.currentStandard.status === "ACT." ||
      this.currentStandard.status === "INACTIVE"
    ) {
      this.stepOneDisabled = true;
      this.stepTwoDisabled = true;
      this.stepThreeDisabled = true;
      this.stepFourDisabled = true;
      this.stepFiveDisabled = true;
      this.stepSixDisabled = true;
      // 7
      this.stepSevenDisabled = false;
      this.activeStep = 7;
      this.router.navigate(["/dashboard/create-operating-standard/step-seven"]);
    } else {
      if (this.currentStandard.language.toLowerCase() === "russian") {
        // RUSSIAN
        if (
          this.currentStandard.ruName !== "" &&
          this.currentStandard.ruName !== null &&
          this.currentStandard.ruAnnotation !== "" &&
          this.currentStandard.ruAnnotation !== null &&
          this.currentStandard.ruFileLink !== null &&
          this.checkListsLengthExecute()
        ) {
          this.afterNewAction();
        } else {
          if (this.currentStandard.status !== "NEW") {
            this.afterNewAction();
          } else {
            this.stepOneDisabled = false;
            this.stepTwoDisabled = false;
            this.stepThreeDisabled = true;
            this.activeStep = 1;
            this.router.navigate(["/dashboard/create-operating-standard"]);
          }
        }
      } else if (this.currentStandard.language.toLowerCase() === "english") {
        // ENGLISH
        if (
          this.currentStandard.enName !== "" &&
          this.currentStandard.enName !== null &&
          this.currentStandard.enAnnotation !== "" &&
          this.currentStandard.enAnnotation !== null &&
          this.currentStandard.enFileLink !== null &&
          this.checkListsLengthExecute()
        ) {
          this.afterNewAction();
        } else {
          if (this.currentStandard.status !== "NEW") {
            this.afterNewAction();
          } else {
            this.stepOneDisabled = false;
            this.stepTwoDisabled = false;
            this.stepThreeDisabled = true;
            this.activeStep = 1;
            this.router.navigate(["/dashboard/create-operating-standard"]);
          }
        }
      }
    }
  }

  afterNewAction() {
    if (this.currentStandard.status.toString() === "UNDER_CONFIRMATION") {
      this.stepOneDisabled = true;
      this.stepTwoDisabled = true;
      this.canGoToDiscussion = false;

      if (this.notifyType === "MODIFY_REQUEST") {
        this.stepFourDisabled = false;
        this.activeStep = 4;
        this.router.navigate([
          "/dashboard/create-operating-standard/step-four"
        ]);
        this.stepThreeDisabled = true;
      } else if (this.notifyType === "CONFIRMATION_FINISHED") {
        this.stepThreeDisabled = false;
        this.stepFourDisabled = true;
        this.stepFiveDisabled = false;
        this.activeStep = 5;
        this.stepThreeDisabled = true;
        this.router.navigate([
          "/dashboard/create-operating-standard/step-five"
        ]);
      } else if (this.currentStandard.readyForFamiliarizationStage) {
        this.stepOneDisabled = true;
        this.stepTwoDisabled = true;
        this.canGoToDiscussion = false;
        this.stepThreeDisabled = true;
        this.stepFourDisabled = true;

        this.stepFiveDisabled = false;
        this.activeStep = 5;
        this.router.navigate([
          "/dashboard/create-operating-standard/step-five"
        ]);
      } else {
        this.activeStep = 3;
        this.stepThreeDisabled = false;
        this.router.navigate([
          "/dashboard/create-operating-standard/step-three"
        ]);
      }
    } else if (this.currentStandard.status.toString() === "NEW") {
      this.canGoToDiscussion = true;
      // 1
      this.stepOneDisabled = false;
      // 2
      this.stepTwoDisabled = false;
      this.dataStandardHasGroups = true;

      // 3
      this.stepThreeDisabled = false;

      this.activeStep = 3;
      this.router.navigate(["/dashboard/create-operating-standard/step-three"]);
    } else if (
      this.currentStandard.status.toString() === "UNDER_FAMILIARIZATION"
    ) {
      this.stepOneDisabled = true;
      this.stepTwoDisabled = true;
      this.canGoToDiscussion = false;
      this.stepThreeDisabled = true;
      this.stepFourDisabled = true;

      this.stepFiveDisabled = false;
      this.activeStep = 5;
      this.router.navigate(["/dashboard/create-operating-standard/step-five"]);
    }
  }

  setNotifyType(nType) {
    this.notifyType = nType;
  }

  // Вызывать метод в ините каждого степа
  // в создании станадртов по группам.
  getCurrentStandard() {
    return this.currentStandard;
  }

  setTempParrentID(pID) {
    this.tempID = pID;
  }

  getTempParrentID() {
    return this.tempID;
  }

  setTempData(standardData) {
    this.tempData = standardData;
  }

  getTempData() {
    return this.tempData;
  }

  // STANDARD INFO:
  goToDiscussion(acknowledgementDays) {
    return this.http.post(
      this.apiURL.goToDiscussion +
        this.getCurrentStandard().id +
        "/toconfirm/" +
        acknowledgementDays,
      null,
      { observe: "response" }
    );
  }

  goToFamiliarization(famDays) {
    return this.http.post(
      this.apiURL.goToFamiliarization +
        this.getCurrentStandard().id +
        "/familiarization/days/" +
        famDays,
      null,
      { observe: "response" }
    );
  }

  goToTestingStage(daysForTesting: number, qBody) {
    return this.http.post(
      this.apiURL.goToTesting +
        this.getCurrentStandard().id +
        "/testing/" +
        daysForTesting,
      qBody,
      { observe: "response" }
    );
  }

  getConfirmatoriesInfo(standardID) {
    return this.http.get(
      this.apiURL.getConfirmatoriesInfo + standardID + "/confirmatories/info",
      { observe: "response" }
    );
  }

  getConfirmatoriesInfoTemp(standardID) {
    return this.http.get(
      this.apiURL.getConfirmatoriesInfo +
        standardID +
        "/confirmatories/info/tmp",
      { observe: "response" }
    );
  }

  getFamiliarizedInfo(standardID) {
    return this.http.get(
      this.apiURL.getFamiliarizeInfo + standardID + "/fam/info",
      { observe: "response" }
    );
  }

  doModifications(modifyStandard) {
    return this.http.post(this.apiURL.doModifications, modifyStandard, {
      observe: "response"
    });
  }

  leaveComponent() {
    // Clear data.
    this.clearTempData();
    this.clearCurrentStandard();
    this.tempID = null;
    // Clear check-box lists
    this.treeGroupPosService.clearPositionsForServerLists();

    // Спбросить шаг на 1.
    this.activeStep = 1;
    // Заблокировать вкладки.
    this.stepOneDisabled = false;
    this.stepTwoDisabled = false;

    this.stepThreeDisabled = true;
    this.stepFourDisabled = true;
    this.stepFiveDisabled = true;
    this.stepSixDisabled = true;
    this.stepSevenDisabled = true;
    this.stepEightDisabled = true;
    this.navPreviousDisabled = true;
    this.navNextDisabled = true;
    this.editActive = false;
    this.editActiveWithNotification = false;

    // Delete dataStandard info
    this.dataStandard = null;
    this.dataStandardFormData = null;
    this.dataStandardNewBlanks = null;
    this.nextToCreate = false;
    this.unlockSThree = false;
    this.dataStandardHasGroups = false;
    this.disGtn = false;
    this.dataStandardFilesUploadError = false;
    this.dataStandardErrorExists = false;
    this.dataStandardErrorCreating = false;

    this.showByFilesAndBlanks = false;
  }

  setEditActive(b: boolean) {
    this.editActive = b;
  }

  getEditActive() {
    return this.editActive;
  }

  setEditActiveWithNotification(b: boolean) {
    this.editActiveWithNotification = b;
  }

  getEditActiveWithNotification() {
    return this.editActiveWithNotification;
  }

  publishStandardNoNotify(sID) {
    return this.http.post(
      this.apiURL.publishStandardNoNotify + sID + "/modify/silent",
      null,
      { observe: "response" }
    );
  }

  publishStandardWithNotify(sID, logBody) {
    return this.http.post(
      this.apiURL.publishStandardWithNotify + sID + "/modify/silent",
      logBody,
      { observe: "response" }
    );
  }

  setLogsID(logsID) {
    this.logsID = logsID;
  }

  getLogsID() {
    return this.logsID;
  }

  sendTranslateQuestionsRequest(id) {
    return this.http.get(this.apiURL.sendTranslateQuestionsRequest + id, {
      observe: "response"
    });
  }

  addQuestionsToStandardHead(id, qBody: MultiQuestions) {
    return this.http.put(
      this.apiURL.addQuestionsToStandardHead + id + "/questions",
      qBody,
      { observe: "response" }
    );
  }

  unlockStepThree(b: boolean) {
    this.unlockSThree = b;
  }

  setDataStandard(
    dataStandard: any,
    standardFormData: FormData,
    standardNewBlanks: NewBlank[]
  ) {
    this.dataStandard = dataStandard;
    this.dataStandardFormData = standardFormData;
    this.dataStandardNewBlanks = standardNewBlanks;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/steps-controller.service.ts